var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.72,28.94l-9.62-9.66c-0.06,0-.09,0-0.09-0.06l-0.09-.06a1.54,1.54,0,0,0-.22-0.09,11.92,11.92,0,0,0,1.72-3.31A12.25,12.25,0,0,0,24,12,12,12,0,0,0,12,0,11.95,11.95,0,0,0,0,12a11.82,11.82,0,0,0,3.5,8.47A11.9,11.9,0,0,0,12,24a11.56,11.56,0,0,0,3.78-.62,11.85,11.85,0,0,0,3.31-1.69,0.12,0.12,0,0,0,0,.09l0.06,0.09a0.16,0.16,0,0,0,.06.09,0.11,0.11,0,0,1,0,.09L29,31.72a1.14,1.14,0,0,0,.72.28,1,1,0,0,0,.66-0.28l1.41-1.37A1.47,1.47,0,0,0,32,29.66a1.14,1.14,0,0,0-.31-0.72h0ZM12,4a8,8,0,0,1,8,8,7.88,7.88,0,0,1-2.31,5.66A8,8,0,0,1,12,20a7.85,7.85,0,0,1-5.66-2.34,7.92,7.92,0,0,1,0-11.31A7.85,7.85,0,0,1,12,4Z",
    transform: "translate(-0.03 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.3b0ca080a2cd3c0d76b96bf020422852.svg";
export { ForwardRef as ReactComponent };